module.exports = {
  // API_HOST:"http://localhost:1337",
  // API_HOST:"http://138.68.85.95:1337",
  // ENVIROMENT: "PROD",
  API_HOST: "http://api.pharm-tmn.ru",
};
